/*
  HTP — free gift cart guard.
  The "Free Edge Guard + Overgrip Kit" is a hidden $0 product added by the
  checkbox on paddle pages. This keeps the cart honest:
    - kit quantity can never exceed the number of paddles in the cart
    - if there are no paddles, the kit is removed
  It never ADDS the kit (opt-in only). Runs on page load and after every cart
  update published by the theme (product-form, cart-items, quick-add).
*/
(function () {
  const KIT_HANDLE = 'free-edge-guard-overgrip-kit';
  const PADDLE_TYPE = 'Pickleball Paddle';
  const SOURCE = 'htp-free-gift';
  let running = false;

  function cartUrl(path) {
    const root = (window.routes && window.routes.cart_url) || '/cart';
    return root + path;
  }

  async function enforce() {
    if (running) return;
    running = true;
    try {
      const cart = await fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const items = cart.items || [];
      const paddleQty = items
        .filter((i) => i.product_type === PADDLE_TYPE)
        .reduce((n, i) => n + i.quantity, 0);
      const kitLines = items.filter((i) => i.handle === KIT_HANDLE);
      if (!kitLines.length) return;

      let allowance = paddleQty;
      let changed = false;
      for (const line of kitLines) {
        const target = Math.min(line.quantity, allowance);
        allowance -= target;
        if (target === line.quantity) continue;
        await fetch(cartUrl('/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: target }),
        });
        changed = true;
      }
      if (!changed) return;

      const fresh = await fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (window.publish && window.PUB_SUB_EVENTS) {
        // cart-items / cart-drawer-items re-render themselves on this event
        publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: fresh });
      } else if (document.querySelector('cart-items')) {
        window.location.reload();
      }
    } catch (e) {
      console.warn('[htp-free-gift] guard skipped:', e);
    } finally {
      running = false;
    }
  }

  // Mark the kit's row(s) in the cart page / drawer so CSS can hide the quantity
  // stepper and show the "Free with your paddle" badge (no Liquid edits needed).
  function tagRows() {
    document.querySelectorAll('.cart-item:not(.htp-gift-line)').forEach((row) => {
      if (row.querySelector('a[href*="/products/' + KIT_HANDLE + '"]')) row.classList.add('htp-gift-line');
    });
  }
  let tagTimer = null;
  function watchRows() {
    if (!window.MutationObserver) return;
    new MutationObserver(() => {
      clearTimeout(tagTimer);
      tagTimer = setTimeout(tagRows, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function subscribeToCart() {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === SOURCE) return;
      // let the theme finish its own re-render first
      setTimeout(enforce, 150);
    });
    return true;
  }

  // "Buy it now" (dynamic checkout) skips the theme's add-to-cart JS, so the kit
  // could not ride along. While the box is checked, hide that button so the
  // customer goes through Add to cart -> checkout instead.
  function watchCheckbox() {
    document.addEventListener('change', (e) => {
      const input = e.target;
      if (!input || input.name !== 'htp_free_gift') return;
      const form = input.closest('form');
      if (form) form.classList.toggle('htp-gift-on', input.checked);
    });
  }

  function init() {
    watchCheckbox();
    if (!subscribeToCart()) {
      // pubsub.js loads with defer; retry shortly
      setTimeout(subscribeToCart, 500);
    }
    tagRows();
    watchRows();
    enforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
